// URL pública canônica do app — usada para construir links que vão por email
// ou são compartilhados externamente (reset de senha, convites, portal cliente).
// Override opcional via VITE_APP_URL; default é o domínio de produção.
export const APP_URL =
  (import.meta.env.VITE_APP_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://www.missaocerimonial.com.br';
